import { render, staticRenderFns } from "./UploadArea.vue?vue&type=template&id=1d5ff158&scoped=true"
import script from "./UploadArea.vue?vue&type=script&lang=ts"
export * from "./UploadArea.vue?vue&type=script&lang=ts"
import style0 from "./UploadArea.vue?vue&type=style&index=0&id=1d5ff158&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d5ff158",
  null
  
)

export default component.exports